import React from "react";

export default function ShippingPolicy() {
  return (
    <section className="flex justify-center bg-[#f5f0b5] text-black py-10 px-4">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-4xl p-6 md:p-10">
        
        {/* Title */}
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6">
          Shipping Policy
        </h2>

        {/* Intro */}
        <p className="text-gray-700 text-justify mb-8 leading-relaxed">
          Your apprehensions while shopping for jewellery online are completely
          justified. At <span className="font-semibold">Maysam</span>, we have
          adopted secure and reliable shipping methods to ensure your products
          reach you safely and on time.
        </p>

        {/* Shipping Coverage */}
        <div className="mb-8 text-left text-justify">
          <h3 className="text-2xl font-semibold mb-3">
            Shipping Coverage & Charges
          </h3>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              We offer <strong>free shipping</strong> on all orders within India.
            </li>
            <li>
              International shipments may attract additional delivery charges.
            </li>
            <li>
              All products are fully insured by <strong>Maysam</strong> until they
              reach your doorstep, ensuring a 100% safe purchase.
            </li>
          </ul>
        </div>

        {/* Courier Partners */}
        <div className="mb-8 text-left text-justify">
          <h3 className="text-2xl font-semibold mb-3">
            Courier & Delivery Partners
          </h3>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              We collaborate with trusted courier services for domestic deliveries.
            </li>
            <li>
              International deliveries are handled by reputed partners such as
              <strong> DHL</strong> and <strong>UPS</strong>.
            </li>
            <li>
              To ensure fast and secure delivery, we only ship through reliable
              and reputed courier agencies.
            </li>
          </ul>
        </div>

        {/* Dispatch & Delivery Timeline */}
        <div className="mb-8 text-left text-justify">
          <h3 className="text-2xl font-semibold mb-3">
            Dispatch & Delivery Timeline
          </h3>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              Orders are usually dispatched within <strong>48 hours / 2 business days</strong>.
            </li>
            <li>
              During Indian public holidays, dispatch may take up to
              <strong> 72 hours</strong>.
            </li>
            <li>
              Once shipped, delivery typically takes <strong>2–5 days</strong>,
              depending on your pin code.
            </li>
            <li>
              Estimated delivery times are indicative and begin from the date of dispatch.
            </li>
          </ul>
        </div>

        {/* Special Orders */}
        <div className="mb-8 text-left text-justify">
          <h3 className="text-2xl font-semibold mb-3">
            Customized & Special Orders
          </h3>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              Most orders are delivered within <strong>3–4 working days</strong>,
              including processing time.
            </li>
            <li>
              Some orders may take longer if the item needs to be produced or procured.
            </li>
            <li>
              <strong>Customized orders</strong> have a shipping timeline of
              <strong> 10 working days</strong>.
            </li>
          </ul>
        </div>

        {/* Inspection & Delays */}
        <div className="mb-8 text-left text-justify">
          <h3 className="text-2xl font-semibold mb-3">
            Order Inspection & Delays
          </h3>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              We recommend inspecting your parcel upon delivery for any signs of
              damage or tampering.
            </li>
            <li>
              In rare cases where the complete order cannot be delivered within
              <strong> 15 working days</strong>, you may request cancellation of
              the unshipped items.
            </li>
            <li>
              Refunds for unshipped items will be processed to your original
              payment method.
            </li>
          </ul>
        </div>

      </div>
    </section>
  );
}
